import { z } from 'zod';
import { ProductDetailsSchema, ProductItemSchema } from './product.schema';

export const CreateOrderSchema = z.object({
   productItemId: z.string(),
   entries: z.number(),
   paymentType: z.string(),
});

export const OrderItemSchema = z.object({
   orderId: z.string(),
   // productItem: ProductItemSchema,
   quantity: z.number(),
   price: z.number(),
   name: z.string().nullable(),
   image: z.string().nullable(),
   sku: z.string().nullable(),
   type: z.string(),
   levelRequired: z.number().nullable(),
   description: z.string().nullable(),
   variant: z.string().nullable(),
   createdAt: z.string(),
   updatedAt: z.string(),
   details: ProductDetailsSchema.array().nullable(),
});

export const OrderSchema = z.object({
   id: z.string(),
   number: z.string(),
   userId: z.string(),
   total: z.number(),
   status: z.string(),
   fullName: z.string().nullable(),
   phone: z.string().nullable(),
   email: z.string().nullable(),
   telegram: z.string().nullable(),
   twitter: z.string().nullable(),
   address: z.string().nullable(),
   state: z.string().nullable(),
   zip: z.string().nullable(),
   country: z.string().nullable(),
   orderItems: OrderItemSchema.array(),
   createdAt: z.string(),
   updatedAt: z.string(),
   paymentType: z.string(),
});

export const OrdersSchema = z.object({
   pagination: z.object({
      page: z.number(),
      limit: z.number(),
      total: z.number().nullable(),
   }),
   orders: z.array(OrderSchema).nullable(),
});

export const OrdersResponseSchema = z.object({
   count: z.number(),
   orders: z.array(OrderSchema),
});
